/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetAccessibleRequest {
    sessionId?: string;
}

export interface ListEntitlements1Request {
    sessionId?: string;
}

export interface ListFeatures2Request {
    sessionId?: string;
}

/**
 * FeaturesApi - interface
 * 
 * @export
 * @interface FeaturesApiInterface
 */
export interface FeaturesApiInterface {
    /**
     * Returns feature IDs the tenant can access (for nav filtering, route guards)
     * @summary Get accessible feature IDs
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApiInterface
     */
    getAccessibleRaw(requestParameters: GetAccessibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns feature IDs the tenant can access (for nav filtering, route guards)
     * Get accessible feature IDs
     */
    getAccessible(requestParameters: GetAccessibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns active entitlements for the current tenant
     * @summary List tenant entitlements
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApiInterface
     */
    listEntitlements1Raw(requestParameters: ListEntitlements1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns active entitlements for the current tenant
     * List tenant entitlements
     */
    listEntitlements1(requestParameters: ListEntitlements1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns the full feature catalog (filtered by release state for tenant)
     * @summary List all features
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApiInterface
     */
    listFeatures2Raw(requestParameters: ListFeatures2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns the full feature catalog (filtered by release state for tenant)
     * List all features
     */
    listFeatures2(requestParameters: ListFeatures2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class FeaturesApi extends runtime.BaseAPI implements FeaturesApiInterface {

    /**
     * Returns feature IDs the tenant can access (for nav filtering, route guards)
     * Get accessible feature IDs
     */
    async getAccessibleRaw(requestParameters: GetAccessibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/features/accessible`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns feature IDs the tenant can access (for nav filtering, route guards)
     * Get accessible feature IDs
     */
    async getAccessible(requestParameters: GetAccessibleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAccessibleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns active entitlements for the current tenant
     * List tenant entitlements
     */
    async listEntitlements1Raw(requestParameters: ListEntitlements1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/features/entitlements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns active entitlements for the current tenant
     * List tenant entitlements
     */
    async listEntitlements1(requestParameters: ListEntitlements1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listEntitlements1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the full feature catalog (filtered by release state for tenant)
     * List all features
     */
    async listFeatures2Raw(requestParameters: ListFeatures2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/features`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns the full feature catalog (filtered by release state for tenant)
     * List all features
     */
    async listFeatures2(requestParameters: ListFeatures2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listFeatures2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
